import styled from 'styled-components';

const LoadingLine = styled.div`
  align-self: center;
  border-radius: 3px;
  height: 16px;
  width: 100%;
`;

export default LoadingLine;
